// AI-CONTEXT: See docs/methodiek-impact-per-euro.md § 6.3 (inbox #347, #343)
import { client } from '../../hooks/Client'
import koppelingAdvies, { groepeerNietMeetellend } from '../../helpers/impactPerEuroMethodiek/koppelingAdvies'

/**
 * Wat de gebruiker kan doen bij een reden waarom iets niet meetelt
 * (koppelingAdvies), met een knop naar het scherm waar dat kan.
 * @param {object} props
 * @param {string|null|undefined} props.code - reasonCode of redenCode
 * @param {(pad: string) => void} props.onNavigate - Opent het scherm van de link
 */
const AdviesRegel = ({ code, onNavigate }) => {
    const advies = koppelingAdvies(code, client)
    if (!advies) return null
    return (
        <span className='impact-per-euro-advice'>
            {advies.tekst}
            {advies.link && (
                <button type='button' className='impact-per-euro-link' onClick={() => onNavigate(advies.link.pad)}>
                    {`${advies.link.label} →`}
                </button>
            )}
        </span>
    )
}

/**
 * Het blok 'Telt niet mee': per reden één kop met wat je eraan kunt doen,
 * daaronder de effecten of de ladder met hun aantal, en waar bekend de
 * deelnemers bij naam (een link naar hun pagina). Gedeeld door de
 * detailpagina's 'Impact per euro' en 'Maatschappelijke waarde', zodat een
 * tekst op één plek staat (koppelingAdvies).
 *
 * @param {object} props
 * @param {Array<import('../../helpers/impactPerEuroMethodiek/buildLinkedMeasurementBreakdown').KoppelingRij>} props.rows - `notCounted` uit buildLinkedMeasurementBreakdown
 * @param {(pad: string) => void} props.onNavigate - Opent een scherm (history.push)
 */
const NotCountedGroups = ({ rows, onNavigate }) => (
    <>
        {groepeerNietMeetellend(rows).map((groep) => (
            <div className='impact-per-euro-reason-group' key={groep.key}>
                <div className='impact-per-euro-reason-head'>
                    <span className='impact-per-euro-reason'>{groep.reason}</span>
                    <AdviesRegel code={groep.reasonCode} onNavigate={onNavigate} />
                </div>
                {groep.rijen.map((rij) => (
                    <div className='participation-detail-component-row' key={rij.key}>
                        <span className='lbl'>
                            {rij.label}
                            {rij.personas && rij.personas.length > 0 && (
                                <span className='impact-per-euro-personas'>
                                    {rij.personas.map((persona) => (
                                        <button
                                            type='button'
                                            key={persona.id}
                                            className='impact-per-euro-persona-link'
                                            onClick={() => onNavigate(`/${client}/personabuilder/${persona.id}`)}
                                        >
                                            {persona.name}
                                        </button>
                                    ))}
                                </span>
                            )}
                        </span>
                        {/* Een streepje, geen 0: bij een effect zonder bedragen worden de
                            antwoorden niet opgehaald, dus het aantal is onbekend — en een 0
                            leest als 'niemand gemeten'. */}
                        <span className='val'>{rij.count === null ? '—' : rij.count}</span>
                    </div>
                ))}
            </div>
        ))}
    </>
)

export default NotCountedGroups
export { AdviesRegel }
